/* src/app/private/components/manage-campaign/add-campaign/add-campaign.component.scss */
.field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 25px;
}
label {
  font-weight: 500;
  margin-bottom: 5px;
  font-size: 14px;
}
.p-error {
  font-size: 12px;
  color: red;
}
.requiredValue::after {
  content: "*";
  color: red;
}
/*# sourceMappingURL=add-campaign.component.css.map */
